import { IAnimationStateListener } from "pixi-spine";
import { State } from "../../../vendor_core/core/src/states/State";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import BURFeatureModel from "../models/BURFeatureModel";
import BURReelSymbol from "../view/BURReelSymbol";
import BURReelsModel from "../models/BURReelsModel";
import { playSceneShake, stopSceneShake } from "../view/SceneShake";
import gsap from "gsap";
import { GameLayers } from "../enums/GameLayers";

const color = "yellow";

export default class BURPlayEnergyChargeState extends State {
    public async enter() {
        super.enter();

        const buffaloRush = ViewManager.getLayer(GameLayers.Buffalos)
            .getCurrentScene()
            .spineAnimations.get("buffalo")!;

        const listener: IAnimationStateListener = {
            event(_, event) {
                if (event.data.name === "add_symbols") {
                    BURFeatureModel.energy_coins.map((coin) => {
                        const reel = BURReelsModel.reels.reels[coin.x];
                        const symbol = reel.symbols[coin.y] as BURReelSymbol;
                        symbol.setIsMystery(false);
                        symbol.setId(
                            BURReelsModel.energy_coin_ids.get(coin.color)!
                        );
                        symbol.y = reel.symbolsPositions[coin.y].y;
                        symbol.setIsLocked(true);
                    });
                }
            }
        };

        buffaloRush.state.addListener(listener);

        // Scene shake
        playSceneShake(BURReelsModel.shake_layers);

        gsap.delayedCall(1, async () => {
            // Start buffalo rush
            buffaloRush.visible = true;
            await buffaloRush.playAsync(color);

            // Clearup
            stopSceneShake();
            buffaloRush.state.removeListener(listener);
            buffaloRush.visible = false;

            await BURReelsModel.reels.playEnergyCharge();

            this.exit();
        });
    }
}
